import { Controller } from "@hotwired/stimulus";
import { useDocumentListener, useElementListener } from "lib/event_helpers";
import { isMobileWidth } from "lib/window_helper";
import * as Bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ['inlineQuestions'];

  relatedQuestionsCollapse = null;

  connect() {
    useDocumentListener(this, 'chat--message:new', this.hideTrigger);
    useDocumentListener(this, 'chat--broadcast:complete', this.showTriggerConditionally);

    useElementListener(this, this.inlineQuestionsTarget, 'shown.bs.collapse', this.dispatchCompleteEvent);
    useElementListener(this, this.inlineQuestionsTarget, 'hidden.bs.collapse', this.dispatchCompleteEvent);
  }

  hideTrigger() {
    this.hideRelatedQuestions();
    this.element.classList.add('hidden');
  }

  showTriggerConditionally(event) {
    const { detail } = event;
    const { content } = detail;
    const { responseType } = content;

    if (['exact', 'near'].includes(responseType))
      this.showTrigger();
  }

  showTrigger() {
    this.element.classList.remove('hidden');
  }

  showRelatedQuestions() {
    if (isMobileWidth()) {
      // Toggle offcanvas
      new Bootstrap.Offcanvas('#offcanvasQuestions').show();
    } else {
      // Toggle inline questions
      const collapse = new Bootstrap.Collapse(this.inlineQuestionsTarget);
      this.dispatch('show');
    }
  }

  dispatchCompleteEvent() {
    this.dispatch('complete');
  }

  hideRelatedQuestions() {
    new Bootstrap.Collapse(this.inlineQuestionsTarget, { toggle: false }).hide();
    this.dispatchCompleteEvent();
  }
}